<template>
    <x-page :title="title">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" :click-handler="handleBackButtonClick" />
        </template>

        <x-table :headers="['#', 'Sesi', 'Mulai', 'Selesai', 'Peserta', '']" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    {{ resource.label }}
                </td>
                <td class="nowrap">
                    {{ resource.start_at | datetime }}
                </td>
                <td class="nowrap">
                    {{ resource.end_at | datetime("-") }}
                </td>
                <td>
                    <button class="btn btn-link" @click="showSubscriberModal(resource)">
                        {{ resource.subscribers.length }} peserta
                    </button>
                </td>
                <td>
                    <x-quick-delete-button @click="deleteResource(resource)" :disabled="isLoading" />
                    <a
                        class="btn btn-success"
                        :href="`/admin/event-forms/subscribers/${event_form_id}/session/${resource.id}/add`"
                    >
                        <i class="fa fa-plus mr-3"></i>
                    </a>
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" :query="filters" />

        <event-form-session-subscriber-modal
            id="subscriber-modal"
            :session="selectedResource"
            @subscriber-deleted="() => fetchResources()"
        />
    </x-page>
</template>

<script>
import XAjaxDropdown from "../../components/XAjaxDropdown.vue";
import XBackButton from "../../components/XBackButton.vue";
import XCreateButton from "../../components/XCreateButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XFilterBox from "../../components/XFilterBox.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import { deletePrompt, handleGeneralXhrError } from "../../helpers";
import FilterableMixin from "../../mixins/FilterableMixin";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import XPagination from "../../components/XPagination.vue";
import EventFormSessionSubscriberModal from "./EventFormSessionSubscriberModal.vue";
import XAddItemButton from "../../components/XAddItemButton.vue";

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XAddItemButton,
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XBackButton,
        XPagination,
        EventFormSessionSubscriberModal,
    },
    computed: {
        title() {
            if (this.form) return `Absensi ${this.form.label}`;
        },
    },
    created() {
        this.fetchForm();
        this.preselectFilters({});
        this.handleFilter(1, true).catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            form: null,
            isLoading: false,
            resources: null,
            event_form_id: null,
            selectedResource: null,
        };
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.label,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios.delete(`/api/event-form-sessions/${resource.id}`).then(() => {
                        this.$notify({
                            type: "success",
                            title: `Berhasil`,
                            text: `${resource.label} dihapus!`,
                        });
                        this.fetchResources();
                    });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchForm(route = this.$route) {
            this.isLoading = true;
            const request = axios.get(`/api/event-forms/${route.params.id}`).then((response) => {
                this.form = response.data.data;
            });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get(`/api/event-forms/${route.params.id}/sessions`, {
                    params: {
                        ...route.query,
                        with: ["subscribers"],
                        without_global_scopes: 1,
                    },
                })
                .then((response) => {
                    this.$set(this, "resources", response.data.data);
                    this.$set(this, "event_form_id", route.params.id);
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        handleBackButtonClick(router) {
            router.back();
        },
        showSubscriberModal(resource) {
            this.selectedResource = resource;
            $("#subscriber-modal").modal("show");
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>
